import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { homeCardHover, homeSectionPaper } from "../home/homeStyles";
import {
  communityRosterPath,
  filledPlayerNames,
  publicRosterPath,
  rosterOwnerLabel,
} from "../../utils/community";

const RosterCard = ({ roster, sport, publicView = false }) => {
  if (!roster) return null;
  const to = publicView
    ? publicRosterPath(roster)
    : communityRosterPath(sport, roster.slug || roster.id);
  const names = filledPlayerNames(roster);

  return (
    <Box
      component={RouterLink}
      to={to}
      sx={{
        ...homeSectionPaper,
        ...homeCardHover,
        textDecoration: "none",
        color: "inherit",
        p: 2,
        minWidth: 240,
        display: "block",
      }}
    >
      <Box sx={{ display: "flex", gap: 1, mb: 1, flexWrap: "wrap" }}>
        {roster.official && <Chip size="small" label="Stats.fan Official" />}
        {roster.sourceType === "fanPage" && (
          <Chip size="small" variant="outlined" label="Published lineup" />
        )}
      </Box>
      <Typography variant="subtitle1" fontWeight={700}>
        {roster.title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
        {rosterOwnerLabel(roster)}
        {roster.inspiredByLabel ? ` · Inspired by ${roster.inspiredByLabel}` : ""}
      </Typography>
      {names.length > 0 && (
        <Typography variant="body2" sx={{ mt: 1.25 }}>
          {names.join(" · ")}
        </Typography>
      )}
    </Box>
  );
};

export default RosterCard;
